// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CoachingSessionCoachingSessionFragmentDoc } from './CoachingSession.generated';
import {
  ScheduleModalCoachingSessionFragmentDoc,
  ScheduleModalCoachFragmentDoc,
} from '../modals/__generated-gql-types__/ScheduleModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpcomingSessionsCtaCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  canceled: boolean;
  summary?: string | null;
  hasRecording: boolean;
  additionalTimeToBuy: number;
  name: string;
  sessionType: Types.CoachingSessionType;
  durationInMinute: number;
  startAt: number;
  endAt: number;
  content:
    | {
        __typename: 'BootcampSession';
        bootcamp: { __typename?: 'Bootcamp'; id: string; slug: string };
      }
    | {
        __typename: 'Class';
        id: string;
        slug?: string | null;
        isFreeEvent?: boolean | null;
      }
    | { __typename: 'EventSession' }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        order?: { __typename?: 'Order'; status: Types.OrderStatus } | null;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
  attendees?: Array<{
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }> | null;
  recurringSession?: {
    __typename?: 'RecurringSession';
    id: string;
    formattedCadence: string;
    cadence: {
      __typename?: 'RecurringCadence';
      type: Types.RecurrenceType;
      dayOfWeek?: Types.DayOfWeek | null;
      weekOfMonth?: number | null;
      interval?: number | null;
      isLastWeekOfMonth?: boolean | null;
      startHour: number;
      startMinute: number;
      durationMinutes: number;
    };
  } | null;
};

export type UpcomingSessionsCtaCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  hourlyRate?: number | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  averageReviewRate: number;
  reviewTotal: number;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    upcomingEnrolledSessions?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      canceled: boolean;
      summary?: string | null;
      hasRecording: boolean;
      additionalTimeToBuy: number;
      name: string;
      sessionType: Types.CoachingSessionType;
      durationInMinute: number;
      startAt: number;
      endAt: number;
      content:
        | {
            __typename: 'BootcampSession';
            bootcamp: { __typename?: 'Bootcamp'; id: string; slug: string };
          }
        | {
            __typename: 'Class';
            id: string;
            slug?: string | null;
            isFreeEvent?: boolean | null;
          }
        | { __typename: 'EventSession' }
        | {
            __typename: 'OneOnOneSession';
            title: string;
            order?: { __typename?: 'Order'; status: Types.OrderStatus } | null;
            introOrder?: {
              __typename?: 'Order';
              introCall?: {
                __typename?: 'IntroCall';
                packages?: Array<{
                  __typename?: 'OfferingPackage';
                  id: string;
                }> | null;
              } | null;
            } | null;
          };
      coach: {
        __typename?: 'Coach';
        id: string;
        user: { __typename?: 'User'; id: string; firstName: string };
      };
      attendees?: Array<{
        __typename?: 'Applicant';
        id: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
        };
      }> | null;
      recurringSession?: {
        __typename?: 'RecurringSession';
        id: string;
        formattedCadence: string;
        cadence: {
          __typename?: 'RecurringCadence';
          type: Types.RecurrenceType;
          dayOfWeek?: Types.DayOfWeek | null;
          weekOfMonth?: number | null;
          interval?: number | null;
          isLastWeekOfMonth?: boolean | null;
          startHour: number;
          startMinute: number;
          durationMinutes: number;
        };
      } | null;
    }> | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
    };
  }> | null;
};

export type UpcomingSessionsCtaGetCoachByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['CoachUrn']['input'];
}>;

export type UpcomingSessionsCtaGetCoachByIdQuery = {
  __typename?: 'Query';
  coach?: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    tier: Types.SkuTier;
    hourlyRate?: number | null;
    couldScheduleIntro?: boolean | null;
    everHadCoachingSessionWithCoach?: boolean | null;
    averageReviewRate: number;
    reviewTotal: number;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      paidTimeInMinute?: number | null;
      upcomingEnrolledSessions?: Array<{
        __typename?: 'CoachingSession';
        id: string;
        canceled: boolean;
        summary?: string | null;
        hasRecording: boolean;
        additionalTimeToBuy: number;
        name: string;
        sessionType: Types.CoachingSessionType;
        durationInMinute: number;
        startAt: number;
        endAt: number;
        content:
          | {
              __typename: 'BootcampSession';
              bootcamp: { __typename?: 'Bootcamp'; id: string; slug: string };
            }
          | {
              __typename: 'Class';
              id: string;
              slug?: string | null;
              isFreeEvent?: boolean | null;
            }
          | { __typename: 'EventSession' }
          | {
              __typename: 'OneOnOneSession';
              title: string;
              order?: {
                __typename?: 'Order';
                status: Types.OrderStatus;
              } | null;
              introOrder?: {
                __typename?: 'Order';
                introCall?: {
                  __typename?: 'IntroCall';
                  packages?: Array<{
                    __typename?: 'OfferingPackage';
                    id: string;
                  }> | null;
                } | null;
              } | null;
            };
        coach: {
          __typename?: 'Coach';
          id: string;
          user: { __typename?: 'User'; id: string; firstName: string };
        };
        attendees?: Array<{
          __typename?: 'Applicant';
          id: string;
          user: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            pictureLink?: string | null;
          };
        }> | null;
        recurringSession?: {
          __typename?: 'RecurringSession';
          id: string;
          formattedCadence: string;
          cadence: {
            __typename?: 'RecurringCadence';
            type: Types.RecurrenceType;
            dayOfWeek?: Types.DayOfWeek | null;
            weekOfMonth?: number | null;
            interval?: number | null;
            isLastWeekOfMonth?: boolean | null;
            startHour: number;
            startMinute: number;
            durationMinutes: number;
          };
        } | null;
      }> | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
    } | null;
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      id: string;
      category: {
        __typename?: 'Category';
        id: string;
        slug: string;
        name: string;
      };
    }> | null;
  } | null;
};

export const UpcomingSessionsCtaCoachingSessionFragmentDoc = gql`
  fragment UpcomingSessionsCTA_CoachingSession on CoachingSession {
    content {
      __typename
      ... on OneOnOneSession {
        title
        order {
          status
        }
      }
    }
    ...CoachingSession_CoachingSession
    ...ScheduleModal_CoachingSession
  }
  ${CoachingSessionCoachingSessionFragmentDoc}
  ${ScheduleModalCoachingSessionFragmentDoc}
`;
export const UpcomingSessionsCtaCoachFragmentDoc = gql`
  fragment UpcomingSessionsCTA_Coach on Coach {
    id
    slug
    ...ScheduleModal_Coach
    coachingRelationship {
      id
      upcomingEnrolledSessions {
        ...UpcomingSessionsCTA_CoachingSession
      }
    }
  }
  ${ScheduleModalCoachFragmentDoc}
  ${UpcomingSessionsCtaCoachingSessionFragmentDoc}
`;
export const UpcomingSessionsCtaGetCoachByIdDocument = gql`
  query UpcomingSessionsCTA_GetCoachById($id: CoachUrn!) {
    coach(id: $id) {
      ...UpcomingSessionsCTA_Coach
    }
  }
  ${UpcomingSessionsCtaCoachFragmentDoc}
`;

/**
 * __useUpcomingSessionsCtaGetCoachByIdQuery__
 *
 * To run a query within a React component, call `useUpcomingSessionsCtaGetCoachByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingSessionsCtaGetCoachByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingSessionsCtaGetCoachByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpcomingSessionsCtaGetCoachByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpcomingSessionsCtaGetCoachByIdQuery,
    UpcomingSessionsCtaGetCoachByIdQueryVariables
  > &
    (
      | {
          variables: UpcomingSessionsCtaGetCoachByIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpcomingSessionsCtaGetCoachByIdQuery,
    UpcomingSessionsCtaGetCoachByIdQueryVariables
  >(UpcomingSessionsCtaGetCoachByIdDocument, options);
}
export function useUpcomingSessionsCtaGetCoachByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpcomingSessionsCtaGetCoachByIdQuery,
    UpcomingSessionsCtaGetCoachByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpcomingSessionsCtaGetCoachByIdQuery,
    UpcomingSessionsCtaGetCoachByIdQueryVariables
  >(UpcomingSessionsCtaGetCoachByIdDocument, options);
}
export function useUpcomingSessionsCtaGetCoachByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpcomingSessionsCtaGetCoachByIdQuery,
        UpcomingSessionsCtaGetCoachByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UpcomingSessionsCtaGetCoachByIdQuery,
    UpcomingSessionsCtaGetCoachByIdQueryVariables
  >(UpcomingSessionsCtaGetCoachByIdDocument, options);
}
export type UpcomingSessionsCtaGetCoachByIdQueryHookResult = ReturnType<
  typeof useUpcomingSessionsCtaGetCoachByIdQuery
>;
export type UpcomingSessionsCtaGetCoachByIdLazyQueryHookResult = ReturnType<
  typeof useUpcomingSessionsCtaGetCoachByIdLazyQuery
>;
export type UpcomingSessionsCtaGetCoachByIdSuspenseQueryHookResult = ReturnType<
  typeof useUpcomingSessionsCtaGetCoachByIdSuspenseQuery
>;
export type UpcomingSessionsCtaGetCoachByIdQueryResult = Apollo.QueryResult<
  UpcomingSessionsCtaGetCoachByIdQuery,
  UpcomingSessionsCtaGetCoachByIdQueryVariables
>;
